import styles from "./AdherentesList.module.css";

const AdherentesList = ({ adherentes }) => {
  if (!adherentes || adherentes?.length === 0) return null;

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>Adherentes</h4>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>Nombre</th>
              <th className={styles.th}>DNI</th>
            </tr>
          </thead>
          <tbody>
            {adherentes.map((adherente, index) => (
              <tr key={index} className={styles.tr}>
                <td className={styles.td}>{adherente.Nombre}</td>
                <td className={styles.td}>{adherente.NroDocPer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdherentesList;
